import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import './StayInformed.css';


const blogMediaItems = [
  { title: 'Blogs', link: 'https://blogs.noctil.com/category/blog/' , icons:['/assets/images/icons/blogicon1.png'] },
  { title: 'Media', link: 'https://blogs.noctil.com/category/media/', icons:['/assets/images/icons/mediaicon.png'] }
];

const StayInformed = ({ title, subTitle }) => {

  return (
    <div className="stay-informed-container">
      <div className="pt--60 pb--60">
        <div className="col-lg-12 text-center">
          <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
            <h2 className="stay-informed-title">{title}</h2>
            <h3 className="stay-informed-subtitle">{subTitle}</h3>
          </ScrollAnimation>
        </div>
        <div className="blog-media-grid">
          {blogMediaItems.map((item, index) => (
            <div key={index} className="blog-media-card">
              <h4 style={{fontSize:'22px', fontWeight:'bold', marginLeft:'-10px'}}>{item.title}</h4>
              <div className="icons">
                {item.icons.map((icon, i) => (
                  <img key={i} src={icon} alt="Icon" className="icon" />
                ))}
              </div>
            </div>
          ))}
          </div>
          <div className="read-more-container">
         {blogMediaItems.map((item, index) => (
          <a className="read-more" key={index} href={item.link} >Read More</a>
          ))}
           </div>
      </div>
    </div>
  );
};

export default StayInformed;
